import yup from 'src/libraries/validator.library';
import {
  IOperatorPilotForm,
  OperatorPilotResponsePayloadSchema,
  OperatorPilotListSchema,
} from 'src/models/operator-pilot.model';
import { httpClient } from 'src/libraries/http.library';

const http = httpClient();

const services = {
  listGET: async () => {
    return http.get('operatorPilots', { limit: 0 }, OperatorPilotListSchema);
  },
  updatePUT: async (id: number, data: IOperatorPilotForm) => {
    return http.put(
      `operatorPilots/${id}`,
      data,
      OperatorPilotResponsePayloadSchema
    );
  },
  addPOST: async (data: IOperatorPilotForm) => {
    return http.post(
      'operatorPilots',
      data,
      OperatorPilotResponsePayloadSchema
    );
  },
  itemDELETE: async (id: number) => {
    return http.delete(`operatorPilots/${id}`, yup.mixed());
  },
};

export default services;
